import createSnackbarSlice from "./snackbar";
import { SnackbarSlice } from "./snackbar.types";

export type { SnackbarSlice };
export default createSnackbarSlice;
